import { connect } from 'react-redux';
import { formValueSelector, change } from 'redux-form';
import DashboardSwapPairPanel from './DashboardSwapPairPanel';
import { onInstrumentSelect } from 'apex-web/lib/redux/actions/buySellActions';
import {
  instrumentsWithProductFullNamesAndProductSymbols,
  selectedInstrumentSelector
} from 'apex-web/lib/redux/selectors/instrumentPositionSelectors';
import { isBuySideBuySellFormSelector } from 'apex-web/lib/redux/selectors/buySellSelectors';
import { isMarginActiveSelector } from 'apex-web/lib/redux/selectors/marginSelectors';
import { getProductByIdSelector } from 'apex-web/lib/redux/selectors/productPositionSelectors';
import config from 'apex-web/lib/config';
import {
  buyValue,
  sellValue
} from 'apex-web/lib/constants/sendOrder/orderEntryFormConstants';

const buySellFormSelector = formValueSelector('buySell');

const mapStateToProps = state => {
  const isMarginActive = isMarginActiveSelector(state);
  let instruments = instrumentsWithProductFullNamesAndProductSymbols(state);
  if (!isMarginActive) {
    const { dealPrices } = config.RetailBuySell;
    const filtered = instruments.filter(instrument =>
      Object.prototype.hasOwnProperty.call(dealPrices, instrument.Symbol)
    );
    if (filtered.length) {
      instruments = filtered;
    }
  }
  const selectedInstrument = selectedInstrumentSelector(state) || {};
  const isBuySide = isBuySideBuySellFormSelector(state);
  const p1Id = selectedInstrument.Product1;
  const p2Id = selectedInstrument.Product2;
  const product1 = p1Id != null ? getProductByIdSelector(state, p1Id) : null;
  const product2 = p2Id != null ? getProductByIdSelector(state, p2Id) : null;

  const quantity = buySellFormSelector(state, 'quantity');
  const price = buySellFormSelector(state, 'price');

  return {
    instruments,
    selectedInstrument,
    isBuySide,
    product1,
    product2,
    quantityDisplay:
      quantity !== undefined && quantity !== null && String(quantity).length
        ? String(quantity)
        : '0',
    priceDisplay:
      price !== undefined && price !== null && String(price).length
        ? String(price)
        : '0'
  };
};

const mapDispatchToProps = dispatch => ({
  onInstrumentSelect: instrumentId => dispatch(onInstrumentSelect(instrumentId)),
  onToggleSide: isBuySide =>
    dispatch(change('buySell', 'side', isBuySide ? sellValue : buyValue))
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const { isBuySide, ...panelState } = stateProps;
  return {
    ...ownProps,
    ...panelState,
    isBuySide,
    onInstrumentSelect: dispatchProps.onInstrumentSelect,
    onToggleSide: () => dispatchProps.onToggleSide(isBuySide)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(DashboardSwapPairPanel);
